// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"autologin_loaderWrapper__2iYQn","loaderLogo":"autologin_loaderLogo__3MnCl"};